import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=2e0b0ddc&scoped=true&"
import script from "./ProcessECREQ.vue?vue&type=script&lang=js&"
export * from "./ProcessECREQ.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=2e0b0ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b0ddc",
  null
  
)

export default component.exports